var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderOutForDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.47461 32.1091C1.47461 32.1091 9.80507 31.0335 19.2763 33.6174C37.29 38.532 38.3177 29.5323 44.9973 25.1928C51.1085 21.2227 56.1697 23.645 62.9741 28.5001C67.9926 32.081 75.3064 38.0919 82.8806 37.1243C89.8043 36.2397 94.7126 29.1897 104.31 27.3968C111.916 25.9758 118.097 29.8797 126.855 28.5001C138.737 26.6287 144.045 15.6112 152.536 15.6112C163.017 15.6112 170.396 6.29297 179.931 6.29297C189.409 6.29297 190.696 11.7723 201.064 15.6112C208.991 18.546 212.805 15.6112 212.805 15.6112V47.0602H1.47461V32.1091Z",
    fill: "url(#paint0_linear_8654_9913)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47461 27.2244C1.47461 27.2244 9.80507 26.1643 19.2763 28.7109C37.29 33.5543 38.3177 24.6849 44.9973 20.4082C51.1085 16.4955 56.1697 18.8828 62.9741 23.6677C67.9926 27.1968 75.3064 33.1206 82.8806 32.167C89.8043 31.2952 94.7126 24.3473 104.31 22.5803C111.916 21.1799 118.097 25.0273 126.855 23.6677C138.737 21.8233 144.045 10.9653 152.536 10.9653C163.017 10.9653 170.396 1.75977 179.931 1.75977C189.409 1.75977 189.913 7.18198 200.281 10.9653C208.208 13.8577 212.805 10.9653 212.805 10.9653",
    stroke: "#1B59F8",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8654_9913",
    x1: 39.6674,
    y1: 26.9785,
    x2: 39.6674,
    y2: 47.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderOutForDelivery);
export default __webpack_public_path__ + "static/media/home-order-outForDelivery.e1c8bf894df2e7a350ee827952e1e528.svg";
export { ForwardRef as ReactComponent };